import { UserState } from "../../stores/User/UserState"

export const createMyInfoUserData = (userState: UserState) => {
    return {
        contentHash: userState.myInfoUserData?.data?.contentHash ?? ``,
        content: userState.myInfoUserData?.data?.content,
    }
}
